import { jwt } from "@common/domain";

export const keycloakToken = jwt;
